export const FETCH_BLOGS_SUCCESS = 'blogs/fetchAllSuccess';
export const FETCH_BLOGS_ERROR = 'blogs/fetchAllError';

export const FETCH_BLOG_SUCCESS = 'blogs/fetchOneSuccess';
export const FETCH_BLOG_ERROR = 'blogs/fetchOneError';
